import { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { Flag } from "lucide-react";
import { api } from "../../lib/api";

// Lets the host swap the two hanging wall banners in the Game Show room for any of the
// available heraldic designs — purely cosmetic, independent of the Wheel/Board/Door elements.
export function GameShowBannerPicker({ currentBanners, onPick }) {
  const [choices, setChoices] = useState([]);

  useEffect(() => {
    api.get("/game-shows/banner-choices").then(({ data }) => setChoices(data.choices || [])).catch(() => {});
  }, []);

  const toggleSlot = (slot, url) => {
    const next = [...currentBanners];
    while (next.length < 2) next.push(choices[0]?.url);
    next[slot] = url;
    onPick(next);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button data-testid="gameshow-banner-picker-trigger" size="sm" variant="secondary" className="rounded-full gap-1.5 h-9">
          <Flag className="w-3.5 h-3.5" /> Banners
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 bg-[#1c1712] border-white/10 text-[#f1e0c5]" data-testid="gameshow-banner-picker-popover">
        {[0, 1].map((slot) => (
          <div key={slot} className="mb-3">
            <p className="text-[10px] uppercase tracking-wider text-[#f1e0c5]/40 mb-1.5">{slot === 0 ? "Left Banner" : "Right Banner"}</p>
            <div className="grid grid-cols-4 gap-1.5">
              {choices.map((c) => (
                <button
                  key={c.id}
                  data-testid={`gameshow-banner-choice-${slot}-${c.id}`}
                  onClick={() => toggleSlot(slot, c.url)}
                  className={`rounded-lg overflow-hidden border-2 ${currentBanners[slot] === c.url ? "border-[#D4AF37]" : "border-transparent"}`}
                  title={c.label}
                >
                  <img src={c.url} alt={c.label} className="w-full h-12 object-cover bg-black/30" />
                </button>
              ))}
            </div>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
